import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MailingAddress } from 'src/app/shop';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-address-card',
    templateUrl: './address-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddressCardComponent {
  @Input() address!: MailingAddress;
  @Input() id!: string;
  @Input() size: 'default' | 'sm' = 'default';
  @Input() isDefaultAddress: boolean = false;
  @Input() hideActions: boolean = false;
  @Input() loadingState: { loadingId: string; action: string } | null = { loadingId: '', action: '' };

  @Input() prefix: string = 'adres-card-';

  @Output() action = new EventEmitter<{ action: string; id: string }>();

  isDevMode = !environment.production;

  constructor() {}

  emitAction(action: string) {
    this.action.emit({
      action: action,
      id: this.address.id,
    });
  }

  get loading(): boolean {
    return this.loadingState?.loadingId === this.id || this.loadingState?.loadingId === this.address.id;
  }
}
